module.exports = __webpack_public_path__ + "img/LENIN.0fda9e1e.png";